import { z } from 'zod'

const DEFAULT_PAGE = 1
const DEFAULT_MAX_ITEMS_PER_PAGE = 20

export const GetSearchResultsSchema = z.object({
    query: z.string().nullish(),
    category: z.string().nullish(),
    /** Brand handle */
    brand: z.string().nullish(),
    condition: z.enum(['BAD', 'GOOD', 'VERY_GOOD', 'NEW']).optional(),
    showOutOfStock: z.boolean().nullish().default(false),
    page: z.number().nullish().default(DEFAULT_PAGE),
    itemsPerPage: z.number().nullish().default(DEFAULT_MAX_ITEMS_PER_PAGE),
    minPrice: z.number().nullish().default(0),
    maxPrice: z.number().nullish(),
    storeId: z.string().nullish(),
    sortBy: z
        .enum([
            'latest',
            'oldest',
            'priceLowToHigh',
            'priceHighToLow',
            'titleAtoZ',
            'titleZtoA',
            'homepage',
        ])
        .nullish()
        .default('latest'),
})
